// AddExpense.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './AddExpense.css';
import { fetchClients } from '../../store/clientsSlice';
import { addExpense, addExpensesBulk, fetchCatgories } from '../../store/expenseSlice'; // Import addExpense thunk

const AddExpense = () => {
  const dispatch = useDispatch();
  
  const { categories, loading: categoriesLoading, error: categoriesError } = useSelector((state) => state.expenses);
  const { clientId, financialYear } = useSelector((state) => state.app);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');
  const[selectedCategory,setSelectedCategory]=useState('');
  const [monthlyForYear, setMonthlyForYear] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchClients());
    dispatch(fetchCatgories());
  }, [dispatch]);

  const handleAddExpense = async () => {
    if (monthlyForYear) {
      // Generate 12 monthly expense entries for the financial year (Apr -> Mar)
      if (!name) {
        setError('Name is required for monthly creation');
        return;
      }
      try {
        const parts = (financialYear || '').split('-');
        const startYear = parseInt(parts[0], 10);
        const endYear = parseInt(parts[1], 10);
        const months = [
          { short: 'Apr', full: 'April', year: startYear },
          { short: 'May', full: 'May', year: startYear },
          { short: 'Jun', full: 'June', year: startYear },
          { short: 'Jul', full: 'July', year: startYear },
          { short: 'Aug', full: 'August', year: startYear },
          { short: 'Sep', full: 'September', year: startYear },
          { short: 'Oct', full: 'October', year: startYear },
          { short: 'Nov', full: 'November', year: startYear },
          { short: 'Dec', full: 'December', year: startYear },
          { short: 'Jan', full: 'January', year: endYear },
          { short: 'Feb', full: 'February', year: endYear },
          { short: 'Mar', full: 'March', year: endYear },
        ];

        const expenses = months.map((m) => ({
          clientId,
          financialYear,
          name: `${name} - ${m.short}`,
          description: `${description && description.length > 0 ? description : name} — ${m.full} ${m.year}`,
          category: selectedCategory,
          amount: parseFloat(amount || 0),
        }));

        await dispatch(addExpensesBulk(expenses)).unwrap();
        setName('');
        setDescription('');
        setAmount('');
        setError('');
        setSelectedCategory('');
        setMonthlyForYear(false);
        navigate('/list-expense');
      } catch (err) {
        console.error('Error adding monthly expenses', err);
        setError('Error adding monthly expenses.');
      }
      return;
    }

    const newExpense = { clientId, financialYear, name, description,category:selectedCategory, amount: parseFloat(amount) };

    try {
      await dispatch(addExpense(newExpense)).unwrap(); // Dispatch addExpense action and wait for it to complete
      setName('');
      setDescription('');
      setAmount('');
      setError('');
      setSelectedCategory('');
      navigate('/list-expense'); // Navigate to the expense list after successful addition
    } catch (err) {
      console.error('Error adding expense', err);
      setError('Error adding expense.');
    }
  };
  return (
    <div className="add-expense-page">
      <h2>Add Expense</h2>
      <p className="financial-page-subtitle">Use the same surface and form layout across operational pages so manual entries feel like one system.</p>
      <div className="expense-form-grid">
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <label style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" checked={monthlyForYear} onChange={(e) => setMonthlyForYear(e.target.checked)} />
          <span>Monthly (whole financial year)</span>
        </label>
        <select onChange={(e) => setSelectedCategory(e.target.value)} value={selectedCategory}>
        <option value="">Select Category</option>
        {categoriesLoading ? (
          <option>Loading...</option>
        ) : categoriesError ? (
          <option>Error loading Categories</option>
        ) : (
          categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))
        )}
      </select>
        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <button className="financial-button" onClick={handleAddExpense}>Add Expense</button>
        {monthlyForYear && (
          <p style={{ gridColumn: '1 / -1', color: '#5d655f' }}>
            This will create 12 monthly entries named like "{name} - Apr" with descriptions like "{description || name} — April {financialYear?.split('-')[0]}".
          </p>
        )}
        {error && <p className="financial-message financial-message--error">{error}</p>}
      </div>
    </div>
  );
};

export default AddExpense;
